import React from "react";
import { Button } from "../../../../../stories/Button/Button";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { LabelProps } from "../../../../../utils/types";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import TextArea from "../../../../../stories/TextArea/TextArea";
import {
  FormAutocomplete,
  formClasses
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { TextField } from "@mui/material";
import Index from "../../masters/supplier/edit/Index";
import DataFetch from "../../../../../images/OpenIcon.svg"
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConfirmOrder = ({ setModalFlag }: Props) => {
  const {itemLabel}=useLabels();
  const {MRFtoPOEntry}=useFormJson();
  return (
    <>
      <div className="confirm-order">
        <div className="confirm-order__title">
          <Title>Conclude {itemLabel} Acceptance</Title>
          <img src={Close} alt="" />
        </div>
        <div className="confirm-order__data row g-0">
          <div className="col confirm-order__data--frame">
            <Title variant="subtitle1">{itemLabel}  Details</Title>
            <div className="confirm-order__data--item-details">
              {MRFtoPOEntry.ItemDetails.map(
                (field: LabelProps, key: React.Key) => {
                  if (field.inputName === "desc_for_rfq" || field.inputName === "used_for" || field.inputName === "remarks") {
                    return (
                      <div className="label-grid" key={key}>
                        <Label>{field.labelName}</Label>
                        <TextArea
                          className={field.className}
                          disabled
                          rows={2}
                          value="abcd"
                        />
                      </div>
                    );
                  } else
                    return (
                      <div className="label-grid">
                        <Label>{field.labelName}</Label>
                        <Input className={field.className} disabled value={1}/>
                      </div>
                    );
                }
              )}
            </div>
          </div>
          <div className="col confirm-order__data--frame">
            <Title variant="subtitle1">Accepted Details</Title>
            <div className="confirm-order__data--accepted">
              {MRFtoPOEntry.AcceptedDetails.map(
                (field: LabelProps, key: React.Key) => {
                  if (field.inputName === "remarks") {
                    return (
                      <div className="label-grid">
                        <Label>{field.labelName}</Label>
                        <TextArea
                          className={field.className}
                          disabled
                          rows={2}
                          value="abcd"
                        />
                      </div>
                    );
                  } else
                    return (
                      <div className="label-grid">
                        <Label>{field.labelName}</Label>
                        <Input className={field.className} disabled value={1}/>
                      </div>
                    );
                }
              )}
          
            </div>
            <div className="confirm-order__data--last-ordered">
            <Title variant="subtitle1">
                <b>Last Ordered Details</b>
              </Title>
              {MRFtoPOEntry.LastOrderedDetails.map(
                (field: LabelProps, key: React.Key) => {
                  return (
                    <div className="label-grid" key={key}>
                      <Label>{field.labelName}</Label>
                      <Input className={field.className} disabled value={1} />
                    </div>
                  );
                }
              )}
            </div>
          </div>
          <div className="col confirm-order__data--frame">
            <Title variant="subtitle1">Confirm Order to Details</Title>
            <div className="confirm-order__data--confirmed">
              {MRFtoPOEntry.ConfirmOrder.map(
                (field: LabelProps, key: React.Key) => {
                  if (field.inputName === "order_supplier_to") {
                    return (
                      <React.Fragment key={key}>
                        <Label>{field.labelName}</Label>
                        <div className="confirm-order__data--accepted--flex">
                          <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={["a", "b"]}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                              }
                            }}
                            openOnFocus
                            forcePopupIcon
                            //   value={formData.priority}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                className={formClasses.formControlRoot}
                              />
                            )}
                          />
                          <img src={DataFetch} alt="" className="data-fetch-icon"/>
                        </div>
                      </React.Fragment>
                    );
                  } else if (field.inputName === "remarks") {
                    return (
                      <React.Fragment>
                        <Label>{field.labelName}</Label>
                        <TextArea rows={2} />
                      </React.Fragment>
                    );
                  } else
                    return (
                      <React.Fragment>
                        <Label>{field.labelName}</Label>
                        <Input className={field.className} />
                      </React.Fragment>
                    );
                }
              )}
            </div>
          </div>
        </div>
        <Button mode="save" />
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default ConfirmOrder;
